export const messages = {
  en: {
    listOwnerCar: {
      searchCondition: 'Search Condition',
      inputCarNum: 'Please enter the license plate number',
      inputParkingSpaceNum: 'Please fill in the parking space number',
      selectParkingSpaceStatus: 'Required, please select the parking space status',
      inputOwnerName: 'Please fill in the owner name',
      inputContact: 'Please enter contact information',
      inputMemberCarNum: 'Please enter member license plate number',
      query: 'Query',
      reset: 'Reset',
      carInfo: 'Car Information',
      importCar: 'Import Cars',
      export: 'Export',
      add: 'Add',
      carNum: 'License Plate Number',
      memberCar: 'Member Car',
      roomNum: 'Room Number',
      carPlateType: 'License Plate Type',
      carType: 'Car Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      validity: 'Validity',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      temporaryCar: 'Temporary Car',
      parkingSpaceReleased: 'Parking space released',
      normal: 'Normal',
      expired: 'Expired',
      noParkingSpace: 'No Parking Space',
      release: 'Release',
      renew: 'Renew',
      buyMonthlyCard: 'Buy Monthly Card',
      modify: 'Modify',
      delete: 'Delete',
      confirmDelete: 'Are you sure to delete?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      importCarTitle: 'Car Import',
      selectFile: 'Select File',
      downloadTemplate: 'Download Template',
      importTemplate: 'Import Template',
      prepareData: 'Prepare data and upload',
      import: 'Import',
      editCar: 'Edit Car',
      carBrand: 'Car Brand',
      inputCarBrand: 'Optional, please fill in the car brand, e.g. BMW X6',
      inputCarNumRequired: 'Required, please fill in the license plate number',
      selectType: 'Required, please select type',
      inputCarColor: 'Optional, please fill in the car color, e.g. white',
      licensePlateType: 'License Plate Type',
      selectLicensePlateType: 'Required, please select license plate type',
      monthlyRentCar: 'Monthly Rent Car',
      soldCar: 'Sold Car',
      internalCar: 'Internal Car',
      freeCar: 'Free Car',
      startRentTime: 'Start Rent Time',
      endRentTime: 'End Rent Time',
      inputStartRentTime: 'Required, please fill in the start rent time',
      inputEndRentTime: 'Required, please fill in the end rent time',
      inputRemark: 'Please fill in remarks',
      save: 'Save',
      deleteCarConfirm: 'Confirm whether to delete',
      fileRequired: 'Required, please select data file',
      invalidExcel: 'Invalid Excel format',
      fileSizeExceed: 'Excel file size cannot exceed 2M',
      importSuccess: 'Import successful',
      importError: 'Import failed',
      updateSuccess: 'Update successful',
      updateError: 'Update failed',
      deleteSuccess: 'Delete successful',
      deleteError: 'Delete failed',
      releaseSuccess: 'Release successful',
      releaseError: 'Release failed',
      exportSuccess: 'Export successful',
      exportError: 'Export failed',
      fetchError: 'Failed to get data',
      allCars: 'All Cars',
      expiredCars: 'Expired Cars',
      downloadFirst: 'Please download first ',
      selectTypeRequired: 'Please select car type',
      selectLicensePlateTypeRequired: 'Please select license plate type',
      rentTimeRequired: 'Please fill in rent time',
      endTimeAfterStart: 'End time must be after start time',
      iotSyncDetail: 'IoT sync details',
      confirmRelease: 'Are you sure to release the car?',
      parkingLot: 'Parking Lot',
    }
  },
  zh: {
    listOwnerCar: {
      searchCondition: '查询条件',
      inputCarNum: '请输入车牌号',
      inputParkingSpaceNum: '请填写车位编号',
      selectParkingSpaceStatus: '必填，请选择车位状态',
      inputOwnerName: '请填写业主名称',
      inputContact: '请输入联系方式',
      inputMemberCarNum: '请输入成员车牌号',
      query: '查询',
      reset: '重置',
      carInfo: '车辆信息',
      importCar: '车辆导入',
      export: '导出',
      add: '添加',
      carNum: '车牌号',
      memberCar: '成员车辆',
      roomNum: '房屋号',
      carPlateType: '车牌类型',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      validity: '有效期',
      status: '状态',
      remark: '备注',
      operation: '操作',
      temporaryCar: '临时车',
      parkingSpaceReleased: '车位已释放',
      normal: '正常',
      expired: '到期',
      noParkingSpace: '无车位',
      release: '释放',
      renew: '续租',
      buyMonthlyCard: '买月卡',
      modify: '修改',
      delete: '删除',
      confirmDelete: '确认删除？',
      cancel: '取消',
      confirm: '确认',
      importCarTitle: '车辆导入',
      selectFile: '选择文件',
      downloadTemplate: '下载模板',
      importTemplate: '导入模板',
      prepareData: '准备数据后，上传导入',
      import: '导入',
      editCar: '修改车辆',
      carBrand: '车品牌',
      inputCarBrand: '可选，请填写车品牌，如宝马X6',
      inputCarNumRequired: '必填，请填写车牌号',
      selectType: '必填，请选择类型',
      inputCarColor: '可选，请填写车颜色，如白色',
      licensePlateType: '车牌类型',
      selectLicensePlateType: '必填，请选择车牌类型',
      monthlyRentCar: '月租车',
      soldCar: '出售车辆',
      internalCar: '内部车',
      freeCar: '免费车',
      startRentTime: '起租时间',
      endRentTime: '结租时间',
      inputStartRentTime: '必填，请填写起租时间',
      inputEndRentTime: '必填，请填写结租时间',
      inputRemark: '请填写备注信息',
      save: '保存',
      deleteCarConfirm: '确认是否删除',
      fileRequired: '必填，请选择数据文件',
      invalidExcel: '不是有效的Excel格式',
      fileSizeExceed: 'Excel文件大小不能超过2M',
      importSuccess: '导入成功',
      importError: '导入失败',
      updateSuccess: '修改成功',
      updateError: '修改失败',
      deleteSuccess: '删除成功',
      deleteError: '删除失败',
      releaseSuccess: '释放成功',
      releaseError: '释放失败',
      exportSuccess: '导出成功',
      exportError: '导出失败',
      fetchError: '获取数据失败',
      allCars: '全部车辆',
      expiredCars: '到期车辆',
      downloadFirst: '请先下载 ',
      selectTypeRequired: '请选择车辆类型',
      selectLicensePlateTypeRequired: '请选择车牌类型',
      rentTimeRequired: '请填写起租时间和结租时间',
      endTimeAfterStart: '结租时间必须大于起租时间',
      iotSyncDetail: '同步物联网详情',
      confirmRelease: '确认释放车辆？',
      parkingLot: '车场',
    }
  }
}